import { render, staticRenderFns } from "./IconThumbDownOutline.vue?vue&type=template&id=5f88c7ec"
import script from "./IconThumbDownOutline.vue?vue&type=script&lang=js"
export * from "./IconThumbDownOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports